import React from 'react';
import { ItemComponentProps, ItemComponent } from '../components/Articles';
import { Container } from '../components/Container';
import { Donate } from '../components/Donate';
import { Newsletter } from '../components/Newsletter';
import { EmailIcon } from '../icons/Email';
import { PhoneIcon } from '../icons/Phone';
import Podcast from "../components/Podcast";

const socialMedias = [
  ['Mastodon', 'https://social.partiarazem.pl/@razem'],
  ['Twitter', 'https://twitter.com/partiarazem'],
  ['Facebook', 'https://www.facebook.com/partiarazem'],
  ['YouTube', 'https://www.youtube.com/c/PartiaRazemPL'],
  ['Instagram', 'https://www.instagram.com/partiarazem/'],
];

const pages = [
  ['Program', '/deklaracja-programowa'],
  ['Dołącz', 'https://dolacz.partiarazem.pl'],
  ['Wesprzyj', 'https://wesprzyj.partiarazem.pl'],
  ['O nas', '/struktura'],
  ['Polityka prywatności', '/polityka-prywatnosci'],
  ['Aktualności', '/aktualnosci'],
  ['English version 🇬🇧', '/home-en', 'en'],
  ['Українська версія 🇺🇦', '/home-ua', 'uk'],
];

const podcastUrl = "https://open.spotify.com/embed/show/6FIeT4U78l7DWw9r1YRXWV";

export interface FooterProps {
  news: ItemComponentProps[] | undefined;
  pathname: string;
}

export const Footer: React.FC<FooterProps> = ({ news, pathname }) => {
  const isInformacje = pathname.startsWith('/informacje');

  return (
    <footer>
      {
        !isInformacje && (
          <>
            <section id="wplacam">
              <Donate />
            </section>
            <section id="newsletter">
              <Newsletter />
            </section>
            <section className="footer__news">
              <h2>Aktualności</h2>
              <div className="footer__news-container">
                {news && news.map((itemProps, index) => (
                  <ItemComponent
                    key={index}
                    {...itemProps}
                    url="/aktualnosci"
                  />
                ))}
              </div>
            </section>
            <section className="footer__podcast">
              <Podcast url={podcastUrl} />
            </section>
          </>
        )
      }
      <Container>
        <footer className="footer">
          <ul className="footer__social">
            {socialMedias.map(([label, url]) => (
              <li key={url}>
                <a
                  href={url}
                  target="_blank"
                  // eslint-disable-next-line react/no-invalid-html-attribute
                  rel="me noreferrer noopener"
                >
                  {label}
                </a>
              </li>
            ))}
          </ul>
          <section className="footer__contact">
            <h2>Kontakt</h2>
            <address itemScope itemType="https://schema.org/Organization">
              <a href="mailto:kontakt@partiarazem.pl">
                <EmailIcon />
                {' '}
                kontakt@partiarazem.pl
              </a>
              <a href="tel:+48663483923">
                <PhoneIcon />
                {' '}
                +48663483923
              </a>
              <div
                className="footer__contact__street"
                itemProp="address"
                itemScope
                itemType="https://schema.org/PostalAddress"
              >
                <span itemProp="streetAddress">Nowy Świat 27</span>
                ,
                {' '}
                <span itemProp="postalCode">00-029</span>
                {' '}
                <span itemProp="addressLocality">Warszawa</span>
              </div>
            </address>
          </section>
          <section className="footer__pages">
            <h2>Strony</h2>
            <ul>
              {pages.map(([label, url, lang = 'pl']) => (
                <li key={url}>
                  <a
                    href={url}
                    target={url.startsWith('http') ? '_blank' : undefined}
                    rel="noopener noreferrer"
                    lang={lang}
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </section>
        </footer>
      </Container>
    </footer>
  );
};
